export default {
    wizardType: "SALESFORCEPARDOT",

    getConnectionParams: (type, model) => ({
        consumerKey: model.get("consumerKey"),
        consumerSecret: model.get("consumerSecret"),
        Username: model.get("username"),
        Password: model.get("password"),
        securityToken: model.get("securityToken"),
        BusinessUnitId: model.get("businessUnitId"),
        apiEndPoint: model.get("host"),
        OAuthAuthorizationFlows: model.get("authMethod"),
        autoAuthTokenRenewal: model.get("authMethod") !== "authToken",
        authToken: model.get("authToken"),
        JWTKeystorePath: model.get("JWTKeystorePath"),
        JWTKeystorePassword: model.get("JWTKeystorePassword"),
        JWTCertificateName: model.get("JWTCertificateName")
    })
};
